import { API } from "../../../util/API";
// tslint:disable-next-line: no-unnecessary-class
export class MessageGearsService {
	static async getJWTToken(
		endpoint: string,
		payload: { username: number; password: string }
	): Promise<{} | undefined> {
		try {
			const response = await API.postReq(endpoint, payload);
			// const response = undefined;

			return response;
		} catch (err) {
			console.warn(err);
		}
	}

	static async submitEmail(
		authorization: string,
		endpoint: string,
		email: string,
		source: string = ".comFooter"
	): Promise<{} | undefined> {
		const payload = {
			recipient: {
				data: {
					EmailAddress: email,
					source
				},
				format: "JSON"
			}
		};
		try {
			const response = await API.postReq(endpoint, payload, authorization);

			return response;
		} catch (err) {
			console.warn(err);
		}
	}
}
